import { useSearchParams } from 'react-router-dom';

export function useDeepLinkParams() {
    const [searchParams, setSearchParams] = useSearchParams();

    const params = {
        tab:               searchParams.get('tab'),
        transactionNo:     searchParams.get('transactionNo'),
        transaction:       searchParams.get('transaction'),
        accountId:         searchParams.get('accountId'),
        id:                searchParams.get('_id'),
        followerAccountId: searchParams.get('followerAccountId'),
        investorAccountId: searchParams.get('investorAccountId'),
        newsId:            searchParams.get('newsId'),
        eventId:           searchParams.get('eventId'),
        baseSymbolId:      searchParams.get('baseSymbolId'),
        symbolCategory:    searchParams.get('symbolMappingCategoryName') || searchParams.get('symbolMappingCategory'),
        type:              searchParams.get('type'),
        email:             searchParams.get('email'),
    };

    const clearDeepLink = () => setSearchParams({}, { replace: true });

    return { params, clearDeepLink };
}
